import { ENV } from './env';

/**
 * DATA MODE — one switch the whole app reads. Live once VITE_API_BASE_URL
 * is set (e.g. to "/api" once the V8 backend is deployed and Nginx proxies
 * it — see deploy/nginx.spa.conf); demo otherwise. Leaving
 * VITE_API_BASE_URL unset — the default in .env.example — keeps every
 * existing demo page working exactly as before. Pages never read this
 * directly; they call dataService, which branches per-function (see
 * services/dataService.ts) so modules not yet wired to the backend keep
 * working on local demo data even once DATA_MODE flips to 'live'.
 */
export type DataMode = 'demo' | 'live';
export const DATA_MODE: DataMode = ENV.apiBaseUrl ? 'live' : 'demo';
